import type { JobDetailsData, JobDetailsSection } from "@stryker/core/types/compositeSections";
import type { ExpandStatus } from "@stryker/core/types/expandable";
import type { ExpandableCards } from "@stryker/core/types/jobs";
import { CompositeJobDetails } from "@/pages/admin/compositeJob/components/JobDetails/CompositeJobDetails";

type JobDetailsProps = {
  savedJobDetails: JobDetailsSection;
  toggleExpandableSection: (section: ExpandableCards) => void;
  setJobDetails: (payload: { data: JobDetailsData; status: ExpandStatus }) => void;
};

export function JobDetails({ savedJobDetails, toggleExpandableSection, setJobDetails }: JobDetailsProps) {
  return (
    <CompositeJobDetails
      savedJobDetails={savedJobDetails}
      setJobDetails={setJobDetails}
      toggleExpandableSection={toggleExpandableSection}
    />
  );
}
